/** Focus helpers shared by Modal, Toolbar, Tabs and Tree. */

const FOCUSABLE = [
  "a[href]",
  "area[href]",
  "button:not([disabled])",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "iframe",
  "[contenteditable='true']",
  "[tabindex]:not([tabindex='-1'])",
].join(",");

/** Tabbable descendants in DOM order, skipping hidden ones. */
export function getFocusable(root: HTMLElement): HTMLElement[] {
  return Array.from(root.querySelectorAll<HTMLElement>(FOCUSABLE)).filter(
    (el) => !el.hasAttribute("inert") && el.getClientRects().length > 0,
  );
}

/**
 * Next index for roving focus with wrap-around.
 * key: ArrowLeft/Right/Up/Down/Home/End. Returns null for other keys.
 */
export function rovingIndex(
  key: string,
  current: number,
  count: number,
  orientation: "horizontal" | "vertical" | "both" = "horizontal",
): number | null {
  if (count <= 0) return null;
  const prevKeys =
    orientation === "vertical" ? ["ArrowUp"] : orientation === "horizontal" ? ["ArrowLeft"] : ["ArrowLeft", "ArrowUp"];
  const nextKeys =
    orientation === "vertical"
      ? ["ArrowDown"]
      : orientation === "horizontal"
        ? ["ArrowRight"]
        : ["ArrowRight", "ArrowDown"];
  if (prevKeys.includes(key)) return (current - 1 + count) % count;
  if (nextKeys.includes(key)) return (current + 1) % count;
  if (key === "Home") return 0;
  if (key === "End") return count - 1;
  return null;
}
